// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckMiniCard-module--container--1V9EO","icon":"CheckMiniCard-module--icon--2oEez","title":"CheckMiniCard-module--title--1zdAu"};